import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { registerAlumni } from '../services/authService';
import './RegisterModal.css';

const initialForm = {
  fullName: '',
  email: '',
  password: '',
  passwordConfirmation: ''
};

export default function RegisterModal({ open, onClose }) {
  const [form, setForm] = useState(initialForm);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();

  if (!open) return null;

  const submit = async (event) => {
    event.preventDefault();
    setError('');

    if (form.password !== form.passwordConfirmation) {
      setError('Password and confirm password do not match.');
      return;
    }

    try {
      await registerAlumni(form);
      setForm(initialForm);
      setShowPassword(false);
      setShowConfirmPassword(false);
      onClose();
      nav(`/verify-email?email=${encodeURIComponent(form.email)}`, { replace: true });
    } catch (err) {
      const nextMessage = String(err?.message || '');
      if (/unable to send verification email right now/i.test(nextMessage)) {
        setForm(initialForm);
        setShowPassword(false);
        setShowConfirmPassword(false);
        onClose();
        nav(`/verify-email?email=${encodeURIComponent(form.email)}`, {
          replace: true,
          state: {
            notice:
              'Registration request was received, but email delivery failed. Please use "Resend code" below.'
          }
        });
        return;
      }
      setError(nextMessage || 'Registration failed.');
    }
  };

  return (
    <div className="register-modal" role="dialog" aria-modal="true">
      <div className="register-overlay" onClick={onClose} aria-hidden="true" />
      <div className="register-popup">
        <button className="register-close" onClick={onClose} aria-label="Close register">
          x
        </button>
        <div className="register-popup-brand">
          <p className="register-popup-eyebrow">Join the network</p>
          <h2>Create your alumni account</h2>
          <p>We will send a code to your email. Enter it to complete registration.</p>
        </div>

        <form className="register-popup-form" onSubmit={submit}>
          <label>
            Full name
            <input
              type="text"
              value={form.fullName}
              onChange={(e) => setForm({ ...form, fullName: e.target.value })}
              required
            />
          </label>
          <label>
            Email address
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>
          <label>
            Password
            <div className="register-password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <button
                type="button"
                className="register-password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>
          <label>
            Confirm password
            <div className="register-password-wrap">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={form.passwordConfirmation}
                onChange={(e) => setForm({ ...form, passwordConfirmation: e.target.value })}
                required
              />
              <button
                type="button"
                className="register-password-toggle"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
              >
                {showConfirmPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          {error && <p className="register-popup-error">{error}</p>}

          <button type="submit" className="register-popup-submit">Create account</button>
        </form>

        <div className="register-popup-footer">
          <span>Already have an account?</span>
          <Link to="/login" onClick={onClose}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
